'use es6';

import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { APP_STATUS } from 'ContentEditorUI/redux/constants';
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import FetchAndCorrectPageSlugContainer from 'page-editor-ui/containers/FetchAndCorrectPageSlugContainer';
import { renderFeedbackLoader, Surveys } from 'ContentEditorUI/lib/csatSurvey';
import { createTracker } from 'usage-tracker';
import { withSessionReplay } from 'usage-tracker-session-replay';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import GlobalContentModal from 'ContentEditorUI/components/modals/GlobalContentModal';
import EmbedModal from 'ContentEditorUI/components/modals/EmbedModal';
import ContentRoutes from 'ContentUtils/Routes';
import LockedModal from 'ContentEditorUI/components/modals/LockedModal';
import { requestFailedOrUninitialized, requestUninitialized } from 'redux-request-state/util/requestStateCheckers';
import events from 'page-editor-ui/events.yaml';
import { getCanSetDynamicPages } from 'page-editor-ui/redux/selectors/pageSettingsSelectors';
import { getContentTypeNounKey } from 'page-editor-ui/redux/selectors/i18nKeySelectors';
import TemplateExistenceCheckContainer from 'ContentEditorUI/containers/TemplateExistenceCheckContainer';
import { getContentTypeName } from 'ContentEditorUI/redux/selectors/contentTypeSelector';
import CopyAsHubLContainer from 'ContentEditorUI/components/CopyAsHubLContainer';
import LegacyPageScaffoldingContainer from 'page-editor-ui/containers/LegacyPageScaffoldingContainer';
import FetchModuleErrors from 'ContentEditorUI/components/app/FetchModuleErrors';
import UpgradableModulePqls from 'page-editor-ui/containers/UpgradableModulePqls';
import CloneRequestModalContainer from 'ContentEditorUI/containers/CloneRequestModalContainer';
import { getIsSitePage, getIsLandingPage, getIsBlogListingPage, getCategoryId, getIsContentFlaggedOrViolated } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { fetchCrmObjectTypes, fetchHubDbTables, fetchDataQueries } from 'page-editor-ui/redux/actions/pageSettingsActions';
import { getSubcategory, getHasContentModel, getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getRoutingCurrentPage } from 'ContentEditorUI/redux/selectors/routingSelectors';
import { getIsStarterPageTemplateAndNoAdvancedFeaturesAccess } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { fetchAccountVerificationStatus } from 'ContentEditorUI/redux/actions/accountVerificationStatusActions';
import { fetchMultiDomainPublishingScopeChange } from 'ContentEditorUI/redux/actions/portalActions';
import { fetchDomainExclusionReason } from 'ContentEditorUI/redux/actions/portalDomainsActions';
import { togglePublishOptionsModalOpen as togglePublishOptionsModalOpenAction } from 'ContentEditorUI/redux/actions/appActions';
import { getAppStatus, getIframeReady, getAddModuleSidebarLoaded, getIsAppReadyForSaving } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getHasAnyContainerOrDndAreaToAddModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getShouldShowScopesHaveChangedModal } from 'ContentEditorUI/redux/selectors/modalSelectors';
import { getPageLimitRequest, getMlangPagesLimitRequest } from 'page-editor-ui/redux/selectors/pageLimitSelectors';
import { getHasPartnerMatchingAppAccess, getCanUseQuickSpot, getHasLandingPagesMultiLangAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
import { fetchBrandColors as fetchBrandColorsAction } from 'ContentEditorUI/redux/actions/brandActions';
import { fetchPageLimit as fetchPageLimitAction, fetchMlangPagesLimit as fetchMlangPagesLimitAction } from 'page-editor-ui/redux/actions/pageLimitActions';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import PageAutoSaveContainer from 'page-editor-ui/containers/PageAutoSaveContainer';
import { autoSaveDebounced as autoSaveDebouncedAction, autoSave as autoSaveAction } from 'page-editor-ui/redux/actions/pageSaveActions';
import PatagoniaModalQueryChecker from 'page-editor-ui/containers/PatagoniaModalQueryChecker';
import { getIsUngatedForPatagonia } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getOpenModal, getRunTestModalOpen } from 'ContentEditorUI/redux/selectors/modalSelectors';
import { MODAL_TYPES, TEST_MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import { getThemePath } from 'ContentEditorUI/redux/selectors/themeSelectors';
import PageOperationsModalSwitch from './PageOperationsModalSwitch';
import { getShouldShowOnboardingModal } from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
import TriggerWootricCsatSurveyContainer, { WootricSurveyNames } from 'ContentEditorUI/containers/TriggerWootricCsatSurveyContainer';
import { isTourCurrentlyActive } from 'onboarding-tours/util/activeTour';
import MlangLimitUpgradeModal from 'page-editor-ui/components/MlangLimitUpgradeModal';
import { CONSUMER_NAME } from 'page-editor-ui/Constants';
import CmsSettingsModals from 'ContentEditorUI/components/modals/CmsSettingsModals';
import { getPageSettingsFullUrl } from '../redux/selectors/pageSettingsSelectors';
import Spotlight from 'page-editor-ui/containers/Spotlight';
import { SectionsLibraryOnboardingTourController } from 'page-editor-ui/components/onboarding/SectionsLibraryOnboardingTour';
import { usePersonalizedPageUrl } from '../hooks/usePersonalizedPageUrl';
import { getHasPersonalizedVariants, getIsPersonalizedVariant } from '../redux/selectors/pageContentModelSelectors';
import { getIsSuggested } from 'ContentEditorUI/redux/selectors/publishSelectors';
import PersonalizationOnboardingBeacons from './PersonalizationOnboardingBeacons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getPageType = (isBlogListingPage, isSitePage) => {
  if (isBlogListingPage) {
    return 'blog-listing-page';
  }
  if (isSitePage) {
    return 'site-page';
  }
  return 'landing-page';
};
const getPersonalizationInfo = ({
  isSuggested,
  isPersonalizedVariant,
  hasPersonalizedVariants
}) => {
  if (isSuggested) {
    if (isPersonalizedVariant) {
      return 'agent-suggested-personalized-variant-page';
    }
    if (hasPersonalizedVariants) {
      return 'agent-suggested-personalized-default-page';
    }
    return 'agent-suggested-page';
  }
  if (isPersonalizedVariant) {
    return 'variant-page';
  }
  if (hasPersonalizedVariants) {
    return 'personalized-default-page';
  }
  return undefined;
};
const mapStateToProps = state => ({
  appIsReadyForSaving: getIsAppReadyForSaving(state),
  appStatus: getAppStatus(state),
  iframeReady: getIframeReady(state),
  addModuleSidebarLoaded: getAddModuleSidebarLoaded(state),
  hasContentModel: getHasContentModel(state),
  currentPage: getRoutingCurrentPage(state),
  isLandingPage: getIsLandingPage(state),
  isSitePage: getIsSitePage(state),
  isBlogListingPage: getIsBlogListingPage(state),
  canSetDynamicPages: getCanSetDynamicPages(state),
  contentNounKey: getContentTypeNounKey(state),
  contentTypeName: getContentTypeName(state),
  category: getCategoryId(state),
  subcategory: getSubcategory(state),
  isPageFlaggedOrViolated: getIsContentFlaggedOrViolated(state),
  isStarterPageTemplateAndNoAdvancedFeaturesAccess: getIsStarterPageTemplateAndNoAdvancedFeaturesAccess(state),
  id: getContentModelId(state),
  pageLimitRequest: getPageLimitRequest(state),
  mlangPagesLimitRequest: getMlangPagesLimitRequest(state),
  shouldShowScopesHaveChangedModal: getShouldShowScopesHaveChangedModal(state),
  hasPartnerMatchingApp: getHasPartnerMatchingAppAccess(state),
  shouldHaveAddModuleSidebar: getHasAnyContainerOrDndAreaToAddModules(state),
  themePath: getThemePath(state),
  isUngatedForPatagonia: getIsUngatedForPatagonia(state),
  canUseQuickSpot: getCanUseQuickSpot(state),
  openModal: getOpenModal(state),
  hasLandingPagesMultiLangAccess: getHasLandingPagesMultiLangAccess(state),
  isPersonalizedVariant: getIsPersonalizedVariant(state),
  hasPersonalizedVariants: getHasPersonalizedVariants(state),
  isSuggested: getIsSuggested(state)
});
const PatagoniaModalSwitch = () => {
  const openModal = useSelector(getOpenModal);
  const shouldShowOnboardingModal = useSelector(state => getShouldShowOnboardingModal(state, CONSUMER_NAME));
  const runTestModalOpen = useSelector(getRunTestModalOpen);
  if ((shouldShowOnboardingModal || openModal === MODAL_TYPES.ONBOARDING_MODAL) && !isTourCurrentlyActive()) {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        PatagoniaOnboardingTourModalContainer
      }) => {
        return /*#__PURE__*/_jsx(PatagoniaOnboardingTourModalContainer, {});
      }
    });
  }
  if (openModal === MODAL_TYPES.SETTINGS_MODAL) {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        PatagoniaSettingsModalContainer
      }) => {
        return /*#__PURE__*/_jsx(PatagoniaSettingsModalContainer, {});
      }
    });
  }
  if (openModal === MODAL_TYPES.MLANG_LIMIT_UPGRADE_MODAL) {
    return /*#__PURE__*/_jsx(MlangLimitUpgradeModal, {});
  }
  if (runTestModalOpen) {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        PatagoniaRunATestContainer
      }) => /*#__PURE__*/_jsx(PatagoniaRunATestContainer, {})
    });
  }
  if (openModal === TEST_MODAL_TYPES.AI_AB_TEST) {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        AiAbTestFlowModal
      }) => /*#__PURE__*/_jsx(AiAbTestFlowModal, {})
    });
  }
  if (openModal === MODAL_TYPES.AILP_THANK_YOU_PAGE_REMINDER) {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        AiLpThankYouPageReminderModal
      }) => /*#__PURE__*/_jsx(AiLpThankYouPageReminderModal, {})
    });
  }
  if (openModal === MODAL_TYPES.CUSTOMER_AGENT_POST_PUBLISH) {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        CustomerAgentPostPublishModal
      }) => /*#__PURE__*/_jsx(CustomerAgentPostPublishModal, {})
    });
  }
  if (openModal === MODAL_TYPES.CONTENT_REMIX_POST_PUBLISH) {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        ContentRemixPostPublishModal
      }) => /*#__PURE__*/_jsx(ContentRemixPostPublishModal, {})
    });
  }
  return /*#__PURE__*/_jsx(PageOperationsModalSwitch, {
    openModalName: openModal
  });
};
const CmsSettingsModalsWrapper = () => {
  const contentId = useSelector(getContentModelId);
  const personalizedPageUrl = usePersonalizedPageUrl({
    contentId
  });
  const contentUrl = useSelector(getPageSettingsFullUrl);
  return /*#__PURE__*/_jsx(CmsSettingsModals, {
    contentUrl: personalizedPageUrl !== null && personalizedPageUrl !== void 0 ? personalizedPageUrl : contentUrl
  });
};
const mapDispatchToProps = {
  fetchCrmObjectTypes,
  fetchHubDbTables,
  fetchAccountVerificationStatus,
  fetchMultiDomainPublishingScopeChange,
  fetchBrandColors: fetchBrandColorsAction,
  fetchPageLimit: fetchPageLimitAction,
  fetchMlangPagesLimit: fetchMlangPagesLimitAction,
  autoSave: autoSaveAction,
  autoSaveDebounced: autoSaveDebouncedAction,
  fetchDataQueries,
  fetchDomainExclusionReason,
  togglePublishOptionsModalOpen: togglePublishOptionsModalOpenAction
};
class ExtraApplicationComponents extends Component {
  // TODO: Is this still needed?

  constructor(props) {
    super(props);
    this.state = {
      hasStartedTourInParentFrame: false,
      hasActiveOnboardingTour: false
    };
  }
  componentDidMount() {
    const {
      hasContentModel,
      isPageFlaggedOrViolated,
      appStatus,
      iframeReady,
      addModuleSidebarLoaded,
      isLandingPage,
      isSitePage,
      canSetDynamicPages,
      id,
      hasLandingPagesMultiLangAccess
    } = this.props;
    if (hasContentModel) {
      if (isPageFlaggedOrViolated) {
        this.redirectToDetailsPage();
        return;
      }
      this.createUsageTrackerAndTrackPageLoad();
      this.props.fetchDomainExclusionReason();
    }
    if (appStatus === APP_STATUS.READY) {
      if (iframeReady && addModuleSidebarLoaded) {
        this.triggerPostWholeAppReadyActions();
      }
    }
    this.props.fetchAccountVerificationStatus();
    this.props.fetchMultiDomainPublishingScopeChange();
    if (isLandingPage || isSitePage) {
      this.props.fetchPageLimit();
      if (id && isSitePage || isLandingPage && hasLandingPagesMultiLangAccess) {
        this.props.fetchMlangPagesLimit(id, isSitePage);
      }
    }
    if (canSetDynamicPages) {
      this.props.fetchHubDbTables();
      this.props.fetchDataQueries();
      this.props.fetchCrmObjectTypes();
    }
  }
  componentDidUpdate(prevProps) {
    const {
      hasContentModel,
      isPageFlaggedOrViolated,
      pageLimitRequest,
      mlangPagesLimitRequest,
      id,
      isLandingPage,
      isSitePage,
      addModuleSidebarLoaded,
      shouldHaveAddModuleSidebar,
      appStatus,
      iframeReady
    } = this.props;
    const isPage = isLandingPage || isSitePage;
    if (!this.state.hasActiveOnboardingTour && isTourCurrentlyActive()) {
      this.setState({
        hasActiveOnboardingTour: true
      });
    }
    if (!prevProps.hasContentModel && hasContentModel) {
      if (!prevProps.isPageFlaggedOrViolated && isPageFlaggedOrViolated) {
        this.redirectToDetailsPage();
        return;
      }
      this.createUsageTrackerAndTrackPageLoad();
      this.props.fetchDomainExclusionReason();
    }
    if (pageLimitRequest && requestFailedOrUninitialized(pageLimitRequest) && isPage) {
      this.props.fetchPageLimit();
    }
    if (mlangPagesLimitRequest && requestUninitialized(mlangPagesLimitRequest) && isPage) {
      this.props.fetchMlangPagesLimit(id, isSitePage);
    }
    const sidebarReady = addModuleSidebarLoaded || !shouldHaveAddModuleSidebar;
    const sidebarPreviouslyReady = prevProps.addModuleSidebarLoaded || !prevProps.shouldHaveAddModuleSidebar;
    const previouslyFullyReady = prevProps.appStatus === APP_STATUS.READY && prevProps.iframeReady && sidebarPreviouslyReady;
    const fullyReadyNow = appStatus === APP_STATUS.READY && iframeReady && sidebarReady;
    if (!previouslyFullyReady && fullyReadyNow) {
      this.triggerPostWholeAppReadyActions();
    }
  }
  triggerPostWholeAppReadyActions() {
    const {
      fetchBrandColors
    } = this.props;
    fetchBrandColors();
  }
  redirectToDetailsPage() {
    const {
      id,
      category,
      subcategory
    } = this.props;
    window.location.href = ContentRoutes.details(id, category, subcategory);
  }
  createUsageTrackerAndTrackPageLoad() {
    const {
      isBlogListingPage,
      isSitePage,
      themePath,
      isPersonalizedVariant,
      hasPersonalizedVariants,
      isSuggested
    } = this.props;
    const pageType = getPageType(isBlogListingPage, isSitePage);
    if (!window.jasmine) {
      const tracker = createTracker({
        events,
        properties: {
          // Required properties
          namespace: 'page-publishing',
          // Optional properties
          pageType,
          screen: `${pageType}-editor`,
          subscreen: this.props.currentPage
        },
        lastKnownEventProperties: ['screen', 'subscreen'],
        clone: true
      });
      const trackerWithSessionReplay = withSessionReplay(tracker);
      UsageTracker.init(trackerWithSessionReplay, 'page-editor-ui');
    }
    UsageTracker.track('pageLoad', {
      themePath
    });
    const originalTracker = UsageTracker.getTracker();
    const tempStandaloneTracker = originalTracker.clone({
      standalone: true
    });
    const personalizationInfo = getPersonalizationInfo({
      isSuggested,
      isPersonalizedVariant,
      hasPersonalizedVariants
    });
    tempStandaloneTracker.track('Page Publishing', 'Pageview', {
      pageType,
      screen: `${pageType}-editor`,
      subscreen: this.props.currentPage,
      personalization: personalizationInfo
    });
  }
  shouldShowBlpBetaSurvey() {
    return this.props.isBlogListingPage && !window.SELENIUM_IS_RUNNING;
  }
  shouldShowLpStarterSurvey() {
    const {
      isLandingPage,
      isStarterPageTemplateAndNoAdvancedFeaturesAccess
    } = this.props;

    // Only show the LP starter survey for landing pages created from starter templates _AND_
    // if the customer is not pro/enterprise (from account or trial)
    return isLandingPage && isStarterPageTemplateAndNoAdvancedFeaturesAccess && !window.SELENIUM_IS_RUNNING;
  }
  getSurvey() {
    if (this.shouldShowBlpBetaSurvey()) {
      return Surveys.BLP_BETA;
    } else if (this.shouldShowLpStarterSurvey()) {
      return Surveys.LP_STARTER_BETA;
    } else {
      return null;
    }
  }
  render() {
    const {
      hasPartnerMatchingApp,
      contentNounKey,
      shouldShowScopesHaveChangedModal,
      contentTypeName,
      autoSave,
      autoSaveDebounced,
      appIsReadyForSaving,
      isUngatedForPatagonia,
      canUseQuickSpot,
      openModal
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(FetchModuleErrors, {}), /*#__PURE__*/_jsx(FetchAndCorrectPageSlugContainer, {}), /*#__PURE__*/_jsx(TemplateExistenceCheckContainer, {
        contentType: contentTypeName
      }), /*#__PURE__*/_jsx(GlobalContentModal, {
        fromAppName: "pageEditor"
        // TBD: Pages / Blog use global content, but other editors may not. Prob
        // put this in extra app container ocmponents, but make blog and page both use a similar component from a seperate lib
      }), /*#__PURE__*/_jsx(EmbedModal, {
        fromAppName: "pageEditor"
      }), /*#__PURE__*/_jsx(LockedModal
      // TBD: Figure out what this does
      , {
        contentNounKey: contentNounKey
      }), hasPartnerMatchingApp && /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
        children: ({
          PartnerMatchingModalContainer
        }) => /*#__PURE__*/_jsx(PartnerMatchingModalContainer, {})
      }), /*#__PURE__*/_jsx(UpgradableModulePqls, {}), /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
        children: ({
          PageScopesHaveChangedModal
        }) => shouldShowScopesHaveChangedModal && /*#__PURE__*/_jsx(PageScopesHaveChangedModal
        // This should prob be extra app container components key
        , {})
      }), isUngatedForPatagonia && /*#__PURE__*/_jsx(PatagoniaModalSwitch, {}), /*#__PURE__*/_jsx(PatagoniaModalQueryChecker, {}), /*#__PURE__*/_jsx(CloneRequestModalContainer, {}), /*#__PURE__*/_jsx(LegacyPageScaffoldingContainer
      // Probably either refactor this out completely
      // or make it universal with config passed in
      , {}), renderFeedbackLoader(this.getSurvey()), /*#__PURE__*/_jsx(PageAutoSaveContainer, {
        autoSaveDebounced: autoSaveDebounced,
        autoSave: autoSave
        // TODO: This is some local component state currently in page application container, lots of weird was previously fully ready but now isn't checks. I wonder if we can just use a selector instead?
        ,
        isAppReadyForSaving: appIsReadyForSaving
      }), /*#__PURE__*/_jsx(CopyAsHubLContainer, {}), /*#__PURE__*/_jsx(TriggerWootricCsatSurveyContainer, {
        surveyName: WootricSurveyNames.PAGES_EDITOR
      }), /*#__PURE__*/_jsx(CmsSettingsModalsWrapper, {}), canUseQuickSpot && openModal === MODAL_TYPES.SPOTLIGHT && /*#__PURE__*/_jsx(Spotlight, {}), /*#__PURE__*/_jsx(SectionsLibraryOnboardingTourController, {}), /*#__PURE__*/_jsx(PersonalizationOnboardingBeacons, {})]
    });
  }
}
ExtraApplicationComponents.propTypes = {
  currentPage: PropTypes.string.isRequired,
  hasContentModel: PropTypes.bool.isRequired,
  isSitePage: PropTypes.bool.isRequired,
  isLandingPage: PropTypes.bool.isRequired,
  isBlogListingPage: PropTypes.bool.isRequired,
  appIsReadyForSaving: PropTypes.bool.isRequired,
  appStatus: PropTypes.string.isRequired,
  iframeReady: PropTypes.bool.isRequired,
  addModuleSidebarLoaded: PropTypes.bool.isRequired,
  isStarterPageTemplateAndNoAdvancedFeaturesAccess: PropTypes.bool.isRequired,
  isPageFlaggedOrViolated: PropTypes.bool,
  id: PropTypes.number,
  category: PropTypes.number,
  subcategory: PropTypes.string,
  fetchMultiDomainPublishingScopeChange: PropTypes.func.isRequired,
  pageLimitRequest: PropTypes.object,
  mlangPagesLimitRequest: PropTypes.object,
  fetchPageLimit: PropTypes.func.isRequired,
  fetchMlangPagesLimit: PropTypes.func.isRequired,
  fetchBrandColors: PropTypes.func.isRequired,
  hasPartnerMatchingApp: PropTypes.bool,
  fetchHubDbTables: PropTypes.func.isRequired,
  fetchCrmObjectTypes: PropTypes.func.isRequired,
  contentNounKey: PropTypes.string.isRequired,
  canSetDynamicPages: PropTypes.bool.isRequired,
  fetchAccountVerificationStatus: PropTypes.func.isRequired,
  shouldShowScopesHaveChangedModal: PropTypes.bool.isRequired,
  shouldHaveAddModuleSidebar: PropTypes.bool.isRequired,
  fetchDataQueries: PropTypes.func.isRequired,
  fetchDomainExclusionReason: PropTypes.func.isRequired,
  contentTypeName: PropTypes.string.isRequired,
  themePath: PropTypes.string,
  hasLandingPagesMultiLangAccess: PropTypes.bool.isRequired,
  isPersonalizedVariant: PropTypes.bool.isRequired,
  hasPersonalizedVariants: PropTypes.bool.isRequired,
  autoSave: PropTypes.func.isRequired,
  autoSaveDebounced: PropTypes.func.isRequired,
  isUngatedForPatagonia: PropTypes.bool.isRequired,
  canUseQuickSpot: PropTypes.bool.isRequired,
  openModal: PropTypes.string
};
ExtraApplicationComponents.contextType = TourContext;
export default connect(mapStateToProps, mapDispatchToProps)(ExtraApplicationComponents);